module.exports = {
    login:{
        title : 'this title',
        username : 'Please enter the user name',
        password : 'Please enter your password',
        email : 'Please enter your email',
        send : 'Send',
        vcode : 'Enter Verification Code from email',
        password_confim : 'Please enter your password again',
        noemail:'Email cannot be empty',
        nopwd:'Password cannot be empty',
        nopwdconfim:'Password confirmation  cannot be empty',
        noverCode:'Verification code cannot be empty',
        nocode:'Eamil verification code cannot be empty',
        pwdconfimerr:'Inconsistent passwords',
        noagreement:'You need to agree to the agreement below to register' ,

    },
    menu:{
      work_manag:'Work management',
      work_add:'Add a work' ,
      base_info:'Base info' ,
    },
    home:{
        personal_info:'Personal info' ,
        exit:'Exit' ,
    },
    _login:'Login',
    _register:'Register',
    _reset:'Reset',
    _web_title:'Writer',
    _writer_agreement: 'If checked, it is deemed to agree to <creator agreement> ',
    _mail:'Mail',
    _nick_name:'Nick name',
    _pen_name:'Pseudonym',
    _address:'Address',
    _region:'Region',
    _id_number:'ID Number',
    _age_type:'Age',
    _country_placeholder:'Please select your country or region' ,
    _imadult:"I'm an adult",
    _imminor:"I'm an minor",
    _real_name:'Real name',
    _photo_id:'Your photo ID',
    _cancel:'Cancel',
    _ok:'Ok',
    _male:'Male',
    _gender:'For Gender',
    _female:'Female',
    _action:'Action',
    _edit:'Edit',
    _loading:'Loading...',
    _delete:'Delete',
    _select_file:'Select File',
    _upload_format_err:'The uploaded picture format is incorrect',
    _upload_size_err:'The size of the uploaded picture cannot be greater than 1M',
    _upload_widhigh_err:'The uploaded image is 450 pixels wide and 600 pixels high',
    _continue_dailog:'Are you sure you want to proceed, continue?',
    _public_dailog:'After the publication, the novel can no longer be edited!',
    _public_chapter_dailog:'After the publication, the Chapter can no longer be edited!',
    _attention:'Attention',
    _add:'Add',
    _add_whole:'Whole book Add',
    _release_selected:'Release Selected',
    _contact_desc:' *If any questions about your submission, please feel free to contact us.',
    _index:'Index',
    _back:'Back',
    _contact_number:'Contact number',
    _required_mail:'Your mail can not be blank!',
    _required_pen_name:'Your pen name can not be blank!',
    _required_phone:'Your phone can not be blank!',
    _required_photo:'Your ID front photo can not be blank!',
    _required_region:'Your region can not be blank!',
    _required_real_name:'Your real name can not be blank!',
    _required_age_type:'Your age can not be blank!',
    _required_address:'Your address can not be blank!',
    _required_id_number:'Your ID Number can not be blank!',
    _input_holder_cover:"1. A cover shall include a novel name<br/>2. A cover shall not include gory and violent content<br/>3. Wishnovel reserves the right to remove any illegal cover directly<br/> 4.Please upload the cover with a resolution of 450px*600px<br/>",
    _input_holder_age:'According to the content of the novel, what age groups are suitable for readers',
    _required_book_title:"Your Book title can not be blank!",
    _required_book_desc:"Your Book brief introduction can not be blank!",
    _required_book_cateids:"Your Book Classification information can not be blank!",
    _required_book_age_limit:"Your Book Age classification of readers can not be blank!",
    _required_book_sex:"Your Book Reader gender classification can not be blank!",
    _required_book_iswz:"Your Book Serial status can not be blank!",

    placeholder_spreator_type:"Please select segmentation method",
    spreator_type:'Spreator Type',
    separator:'Separator',
    number_of_chars:'Number of characters',
    placeholder_separ:'Please enter the chapter separator and pay attention to the width input status',
    placeholder_number:'Please enter the number of words in each chapter. The system will divide the nearest paragraph into chapters after the number of words is met',
    hit_whole_add:'Note: the whole book can be uploaded in TXT format, and all previously uploaded chapters will be cleared after uploading',
    books:{
        classification:'Classification',
        age_classification:'Age Classification',
        all:'all',
        hots:'hots',
        author:'author',
        finished:'finished',
        serial:'serial',
        nofound:'No results were found',
        changeCls:'You can try another classification',
        bookTitle:'Book title',
        long:'long',
        short:'short',
        collection:'collection',
        startReading:'Start reading',
        checkStus:'Check',
        unpublished:'Unpublished',
        checking:'Checking',
        failed:'Failed',
        passed:'Passed',

    },
    novelist:{
        cover:'Cover pic',
        booktitle:'Book title',
        chapters_num:'Chapters',
        finished_status:'Progress',
        chapters:'Chapters',
        release:'Release',
        desc:'Brief introduction' ,
        chapter_title:'Title',
        chapter_content:'Content',
        chapter_content_place:'Please enter chapter content',
        chapter_index:'Chapter index',
        columns:'Columns'
    },
    index:{
      more:'more'
    },
    info:{
        catalogue:'catalogue',
        mobileReading:'Mobile reading',
        download:'download',
        freeReading:'Free reading',
        moreFree:'More free books are here',
        interact:'You can also interact with the author',
        pChapter:'Previous chapter',
        nChapter:'Next chapter',
        tChapters:'Total chapters',
        chapters:'chapters',
        introduction:'Introduction',
        recentUpdates:'Recent updates',
    },
    intro:{

    },
    news_info:{
      updateAt:'Update at',

    },
    search:{
        serachPlaceholder:'Please enter the book name or author name',
        search:'search',
    },
    tops:{
        rankExplain:'explain',
        explain1:'1、The reading completion rate is divided into five gears: 100000 words / 300000 words / 500000 words / 800000 words / 1 million words. Only the highest grade data is displayed. The sorting is based on the weighted calculation value of the existing word completion rate. The more words, the higher the weight',
        explain2:'2、Leaderboards are updated daily',
        explain3:'3、The classification list is sorted by the completion rate of original novels' ,
    },
    _home:'Home',
    status:'Status',
    default:'Default',
    privacyClause:'Privacy clause',
    relatedResult:'Related results' ,
    total:'Total',
    all:'All',
    screen:'Screen',
    agreement:'Agreement',
    loading:'Loading',
    writersZone:'Writers zone',
    rankingList:'Ranking list',
    writerWelfare:'Writer welfare' ,
    library:'Library',
    attention:'Please read carefully'

}